import React from 'react';
import { connect } from 'react-redux';

import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { BankLogoContainer, CardContainer, CardRow } from 'apps/auth/components/form/styles';
import { getBankAlias } from 'apps/auth/helpers/utils';

const Account = (props) => {
    const account = props.account;
    if (account) {
        return (
            <Row indent="adaptive-24-32">
                <CardContainer>
                    <div>
                        <CardRow>
                            <BankLogoContainer>{getBankAlias(account.cardLogo, 'bank')}</BankLogoContainer>
                            {account.alias && <Text ellipsis>{account.alias}</Text>}
                        </CardRow>
                    </div>
                    <div>
                        <Text variant="div" size="secondary" color="secondary" indent="4px">
                            {props.cardsAccountNumber}
                        </Text>
                        <Text variant="div">{account.account}</Text>
                    </div>
                </CardContainer>
            </Row>
        );
    } else {
        return null;
    }
};

const mapStateToProps = (state) => {
    return {
        cardsAccountNumber: state.messages.pageMessages.cardsAccountNumber,
    };
};
export default connect(mapStateToProps)(Account);
